/* RESPONSIBLE TEAM: team-self-serve */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';

export default class PreviewFinRoute extends Route {
  @service iamService;

  beforeModel(_transition) {
    this.iamService.boot();
  }

  queryParams = {
    token: '',
    source: '',
  };
}
